var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2088_16875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10.1698C1.66699 8.26275 1.66699 7.30923 2.09966 6.51879C2.53233 5.72834 3.32278 5.23777 4.90369 4.25661L6.57035 3.22223C8.24148 2.18508 9.07705 1.6665 10.0003 1.6665C10.9236 1.6665 11.7592 2.18508 13.4303 3.22223L15.097 4.25661C16.6779 5.23776 17.4683 5.72834 17.901 6.51879C18.3337 7.30923 18.3337 8.26275 18.3337 10.1698V11.4373C18.3337 14.688 18.3337 16.3134 17.3573 17.3233C16.381 18.3332 14.8097 18.3332 11.667 18.3332H8.33366C5.19096 18.3332 3.61961 18.3332 2.6433 17.3233C1.66699 16.3134 1.66699 14.688 1.66699 11.4373V10.1698Z",
    stroke: "#28475C",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5L10 15",
    stroke: "#28475C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2088_16875"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.7809efb0fe00b2e7f82ed43a91a9341f.svg";
export { ForwardRef as ReactComponent };